import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  loading: false,
  loaded: null,
  error: false,
  data: null,
  jobType: "CL",
};

// Slice
const storeStatusSlice = createSlice({
  name: "storeStatus",
  initialState,
  reducers: {
    getStoreStatus() {},
    setStoreStatus(state, action) {
      const { jobType } = action.payload;
      return {
        ...state,
        jobType,
      };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const {
  getStoreStatus,
  setStoreStatus,
  fetchDataSuccess,
  fetchDataFailure,
} = storeStatusSlice.actions;

export default storeStatusSlice.reducer;

//saga
function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });
    const response = yield call(apiService.get, apiUrl, headers);
    yield put(fetchDataSuccess(response.data));
    if (response?.data) {
      const data = response.data;
      if (data.resultCode === "0000") {
        const { jobType } = data.storeList[0];
        yield put(
          setStoreStatus({
            jobType,
          })
        );
      }
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* storeStatusSaga() {
  yield takeLatest(getStoreStatus.type, fetchDataSaga);
}
